{
  "validation.maxAttachments": "Můžeš připojit maximálně {{max}} příloh.",
  "validation.minAttachments": "je potřeba přiložit alespoň {{min}} přílohy",
  "validation.maxAttachmentSize": "Přílohy nemůžou být větší než {{max}} megabajtů.",
  "validation.attachmentListItemRequired": "Prosím, přilož soubor k \"{{category}}\".",
  "validation.attachmentListItemMaxAttachments": "Povolit můžeš jen {{max}} příloh pro \"{{category}}\".",
  "validation.attachmentListItemMaxAttachmentSize": "Přílohy typu {{category}} nesmí být větší než {{max}} megabajtů.",
  "attachment.bsoCategory.DiagnosticReport": "Diagnostická zpráva",
  "attachment.bsoCategory.InvoiceDocument": "Faktura",
  "attachment.bsoCategory.ShippingDocument": "Přepravní dokument",
  "attachment.bsoCategory.Letter": "Dopis",
  "attachment.bsoCategory.PictureReference": "Obrázek jako reference",
  "attachment.bsoCategory.BugReport": "Hlášení chyby",
  "attachment.bsoCategory.Other": "Jiné",
  "attachment.bsoCategory.Unclassified": "Nezařazeno",
  "attachment.bsoCategory.ServiceForms": "Servisní formulář",
  "attachment.bsoCategory.RegistrationDocument": "Registrační dokument",
  "attachment.bsoCategory.ShopInside": "Fotka interiéru prodejny",
  "attachment.bsoCategory.ShopImageMigration": "Přenos obrázků z obchodu",
  "attachment.bsoCategory.ShopImage": "Fotka výlohy",
  "attachment.uploadButton": "Nahraj {{category}}",
  "attachment.uploadDropdown": "Nahraj soubor"
}